"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxId = exports.isTaxId = void 0;
const validation_1 = require("../validator/validation");
const ValidatorClass_1 = require("../validator/ValidatorClass");
exports.isTaxId = (0, validation_1.isObjectOf)({
    value: validation_1.isString.which((0, validation_1.matchesRegExp)(/^[A-Z0-9/\.\- ]{4,}$/)),
    country: validation_1.isString,
});
class TaxId extends (0, ValidatorClass_1.ValidatorClass)(exports.isTaxId) {
}
exports.TaxId = TaxId;
//# sourceMappingURL=TaxId.js.map